module.exports = __webpack_public_path__ + "static/media/Logo__DigitalOcean.2fa50697.svg";